import React, { Component } from 'react';

//import translate from '../../utils/translate';
import css from './label.scss';

export default class Label extends Component {
	static propTypes = {
		label: React.PropTypes.string.isRequired,
		hideLabel: React.PropTypes.bool,
		btw: React.PropTypes.any,
		name: React.PropTypes.string,
	};

	static defaultProps = {
		hideLabel: false,
		label: '',
		btw: '',
		name: '',
	};

	constructor(props) {
		super();
	}

	render() {
		let className = 'custom-label';

		if (this.props.className) {
			className += ' ' + this.props.className;
		}

		if (this.props.hideLabel) {
			className += ' custom-label--hide';
		}

		return (
			<label className={className}>
				{(!this.props.hideLabel && (this.props.label || this.props.btw)) ? (
					<span className='custom-label__label'>
						{this.props.label}
						{this.props.btw ? (
							<span className='custom-label__label__btw'>{this.props.btw}</span>
						) : false}
					</span>
				) : false}

				{this.props.children}

				{this.props.helpText && (
					<span className='custom-label__helptext' dangerouslySetInnerHTML={{ __html: this.props.helpText }} />
				)}
			</label>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/form/label.js
 **/